import { isEmpty } from 'lodash';

import { AppointmentReceptionService } from '@dreryk/egabinet-appointment-frontend-api';

import { StyledFlex, Text } from '@dreryk/react-components';

import { ReceptionServiceListHeader } from '../../../shared/ReceptionServiceListHeader';
import { ReceptionServiceListEmptyPlaceholder } from '../../../shared/ReceptionServiceListEmptyPlaceholder';

import { StyledReceptionServicePriceText } from './ReceptionServiceList.styled';

type ReceptionServiceListProps = {
   readonly receptionServices: AppointmentReceptionService[];
};

export const ReceptionServiceList = (props: ReceptionServiceListProps): JSX.Element => {
   return (
      <section>
         <ReceptionServiceListHeader />
         {isEmpty(props.receptionServices) ? (
            <ReceptionServiceListEmptyPlaceholder />
         ) : (
            <StyledFlex direction={'column'} gap={'4px'}>
               {props.receptionServices.map((receptionService) => (
                  <StyledFlex
                     key={receptionService.receptionServiceId}
                     gap={'4px'}
                     justifyContent={'space-between'}
                     alignItems={'end'}
                  >
                     <Text testId={'receptionServiceName'}>{receptionService.name}</Text>
                     <StyledReceptionServicePriceText
                        testId={'price'}
                        min={receptionService.minPrice}
                        max={receptionService.maxPrice}
                     />
                  </StyledFlex>
               ))}
            </StyledFlex>
         )}
      </section>
   );
};
